import React from 'react';
import { Text, View } from 'react-native';

import { createChildrenNavigator, createMyAdminNavigator } from './AdminWebNavigators';
import AdminTopBar from './web/AdminTopBar';
import AdminSidebar from './web/AdminSidebar';


import AdminUnitDetailScreen from '../screens/Community/Admin/Units/UnitDetailScreen';
import AdminFeeDetailScreen from '../screens/Community/Admin/Fees/Fees/FeeDetailScreen';
import MainteinancesFeesSettingsScreen from '../screens/Community/Admin/Fees/Fees/MainteinancesFeesSettingsScreen';
import AdminDashboardScreen from "../screens/Community/Admin/DasboardScreen";
import AdminFeesScreen from '../screens/Community/Admin/Fees/FeesScreen';
import AccessControlScreen from '../screens/Community/Admin/AccessControl/AccessControlScreen';
import AdminSettingsScreen from '../screens/Community/Admin/Settings/SettingsScreen';
import AdminUnitsScreen from '../screens/Community/Admin/Units/UnitsScreen';
import AdminFeeUnitScreen from '../screens/Community/Admin/Fees/Fees/FeeUnitScreen';



import PaymentEvidencesScreen from '../screens/Community/Admin/Fees/PaymentEvidences/PaymentEvidencesScreen';
import EvidenceValidatorScreen from '../screens/Community/Admin/Fees/PaymentEvidences/EvidenceValidatorScreen';
import { Platform } from 'react-native';
import AnnouncementDetailScreen from '../screens/Community/Admin/Announcements/AnnouncementDetailScreen';
import AdminUnitBalanceScreen from '../screens/Community/Admin/Fees/Units/UnitBalanceScreen';

// pending
import AdminAnnouncementsScreen from "../screens/Community/Admin/Announcements/AnnouncementsScreen";


// Vinte
import VintePaymentRequestsSection from '@/screens/Vinte/Admin/PaymentRequestsSection';
import VinteProvidersSection from '@/screens/Vinte/Admin/ProvidersSection';
import VinteUnitsScreen from '@/screens/Vinte/Units/VinteUnitsScreen';
import NewPaymentRequestScreen from '@/screens/Vinte/PaymentRequests/NewPaymentRequestScreen';
import PaymentRequestDetailScreen from '@/screens/Vinte/PaymentRequests/PaymentRequestDetailScreen';
import ProviderDetailScreen from '@/screens/Vinte/Providers/ProviderDetailScreen';
import ReportsIndexScreen from '@/screens/Vinte/Reports/ReportsScreen';
import VinteReportDetailScreen from '@/screens/Vinte/Reports/ReportDetailScreen';


import AdminUsersScreen from '@/screens/Community/Admin/Settings/AdminUsersScreen';
import MaintenanceSettingsScreen from '@/screens/Community/Admin/Settings/MaintenanceSettingsScreen';
import QRAccessSettingsScreen from '@/screens/Community/Admin/Settings/QRAccessSettingsScreen';
import NotificationsSettingsScreen from '@/screens/Community/Admin/Settings/NotificationsSettingsScreen';
import QRCategoryConfigScreen from '@/screens/Community/Admin/Settings/QRCategoryConfigScreen';
import ProviderAuthSettingsScreen from '@/screens/Community/Admin/Settings/ProviderAuthSettingsScreen';
import MorosidadSettingsScreen from '@/screens/Community/Admin/Settings/MorosidadSettingsScreen';
import VigilanciaSettingsScreen from '@/screens/Community/Admin/Settings/VigilanciaSettingsScreen';
import GastosSettingsScreen from '@/screens/Community/Admin/Settings/GastosSettingsScreen';
import ReportsSettingsScreen from '@/screens/Community/Admin/Settings/ReportsSettingsScreen';

// Pantallas Accesos
import AccessDashboard from '@/screens/Community/Admin/AccessControl/AccessDashboard.web';
import AccessCamerasScreen from '@/screens/Community/Admin/AccessControl/AccessCamerasScreen';
import ControlCenterScreen from '@/screens/Community/Admin/Sentinel/ControlCenterScreen.web';

// Pantallas Incidencias
import TicketsDashboard from '@/screens/Community/Admin/Tickets/TicketsDashboard.web';

// Pantallas Autorizaciones
import AccessAuthorizationsDashboard from '@/screens/Community/Admin/AccessAuthorizations/AccessAuthorizationsDashboard.web';


/** pantlas prueba
 * Pantallas de prueba 
 * 
const MasterMainScreen = ({ navigation }) => (<View>
  <Text onPress={() => navigation.navigate("Test.Detail")}>Soy Master</Text></View>)
const Detail1Screen = ({ route }) => {
  console.log("Detail1Screen", route)
  return (<View><Text>Soy detail1</Text></View>)
}
const Detail2Screen = ({ route }) => {
  console.log("Detail2Screen", route)
  return (<View><Text>Soy detail2</Text></View>)
}
*/

const ScreenFactory = (screenName: string, navigateTo = "") => ({ route, navigation }: any) => {
  console.log(`%c ${screenName}`, 'color: purple', route)


  //! BORRAR
  // Esto de abajo es el mismo state de AdminWebNavigator.state
  // const state = useNavigationState((state) => state);
  // console.log(state)


  return (<View>
    <Text
      onPress={() => {
        navigation.navigate(navigateTo, {
          // feeId: fee.uuid,
          communityId: route.params?.communityId,
        })
      }}
    >Soy {screenName} {navigateTo ? `Y navego a [${navigateTo}]` : ''}</Text>
    <Text>{route.key}</Text>
  </View>)
}



function WebDemoFullscreenScreen() {
  return (
    <View style={{ flex: 1, padding: 32, backgroundColor: '#fff', borderRadius: 8 }}>
      <Text style={{ fontSize: 28, fontWeight: '700', marginBottom: 16 }}>Demo Fullscreen</Text>
      <Text style={{ fontSize: 14, color: '#555' }}>
        Esta pantalla usa layout="fullscreen". No tiene la columna fija de 400px.
      </Text>
    </View>
  );
}

const DeepStackScreens = [
  { name: "Admin.Home", component: AdminDashboardScreen, options: { title: "Resumen", layout: 'fullscreen' as const } },
  { name: "Admin.Announcements.Index", component: AdminAnnouncementsScreen, options: { title: "Comunicados" } },
  { name: "Test.Home", component: ScreenFactory("DeepStackScreen2", "Test.Detail2") },
  { name: "Admin.Units.Index", component: AdminUnitsScreen, options: { title: "Viviendas" } },
  { name: "Admin.Fees.Index", component: AdminFeesScreen, options: { title: "Finanzas" } },
  { name: "Admin.AccessControl.Index", component: AccessControlScreen, options: { title: "Accesos", layout: 'fullscreen' as const } },
  { name: "Admin.Settings.Index", component: AdminSettingsScreen, options: { title: "Configuración" } },
  { name: "Admin.Web.Demo", component: WebDemoFullscreenScreen, options: { title: "Demo Fullscreen", layout: 'fullscreen' as const } },
  { name: "Admin.AccessControl.EventsDashboard", component: AccessDashboard, options: { title: "Eventos", layout: 'fullscreen' as const } },
  { name: "Admin.Sentinel.ControlCenter", component: ControlCenterScreen, options: { title: "Centro de control", layout: 'fullscreen' as const } },
  { name: "Admin.AccessControl.Cameras", component: AccessCamerasScreen, options: { title: "Cámaras", layout: 'fullscreen' as const } },
  { name: "Admin.Tickets.Index", component: TicketsDashboard, options: { title: "Reportes y solicitudes", layout: 'fullscreen' as const } },
  { name: "Admin.AccessAuthorizations.Index", component: AccessAuthorizationsDashboard, options: { title: "Autorizaciones", layout: 'fullscreen' as const } },
  { name: "Admin.Vinte.PaymentRequests", component: VintePaymentRequestsSection, options: { title: "Solicitudes de pago" } },
  { name: "Admin.Vinte.Providers", component: VinteProvidersSection, options: { title: "Proveedores" } },
  { name: "Admin.Vinte.Units", component: VinteUnitsScreen, options: { title: "Viviendas", layout: 'fullscreen' as const } },
  { name: "Admin.Vinte.Reports", component: ReportsIndexScreen, options: { title: "Reportes" }, initialParams: { detailRoute: "Admin.Vinte.Reports.Detail" } },
]

// Mapa derivado de DeepStackScreens para que AdminLayout sepa qué layout aplicar.
// Pasado al outer navigator via las options del screen "AdminTabStack".
const innerLayouts: Record<string, 'fullscreen' | 'master-detail'> = Object.fromEntries(
  DeepStackScreens
    .filter((s: any) => s.options?.layout)
    .map((s: any) => [s.name, s.options.layout])
);

const MainStackScreens = [
  { name: "AdminTabStack", component: DeepStackNavigator, options: { title: "Dashboard", innerLayouts, initialInnerRoute: DeepStackScreens[0].name } },
  { name: "Test.Detail", component: ScreenFactory("MainStack - Detail1Screen", "Test.Detail2"), options: { title: "Calonsho" } },
  { name: "Test.Detail2", component: ScreenFactory("MainStack - Detail2Screen", "Test.Detail3"), options: { title: "Calonsho" } },
  { name: "Test.Detail3", component: ScreenFactory("MainStack - Detail3Screen", "Test.Detail3"), options: { title: "Calonsho" } },
  { name: "Admin.Units.Detail", component: AdminUnitDetailScreen, options: { title: "Detalle de Vivienda" } },
  // Cuotas: el detalle con ancho tope, como la columna derecha de Accesos.
  { name: "Admin.FeeUnit.Detail", component: AdminFeeUnitScreen, options: { title: "Detalle de Cuota", detailMaxWidth: 650 } },
  { name: "Admin.Fees.Detail", component: AdminFeeDetailScreen, options: { title: "Detalle de Cuota", detailMaxWidth: 650, sideHostWidth: 650, sideDetail: "Admin.FeeUnit.Detail", sideDetailEmpty: "Selecciona una vivienda para ver el detalle de su pago" } },
  { name: "Admin.Fees.Settings", component: MainteinancesFeesSettingsScreen, options: { title: "Configuración de cuota mensual" } },
  { name: "Admin.Payments.Evidences", component: PaymentEvidencesScreen, options: { title: "Comprobantes de Pago", sideDetail: "Admin.Payments.EvidenceDetail", sideDetailEmpty: "Selecciona un comprobante para revisarlo" } },
  { name: "Admin.Payments.EvidenceDetail", component: EvidenceValidatorScreen, options: { title: "" } },

  // Settings screens
  { name: "Admin.Settings.Users", component: AdminUsersScreen, options: { title: "Equipo", detailMaxWidth: 650 } },
  { name: "Admin.Settings.Maintenance", component: MaintenanceSettingsScreen, options: { title: "Mantenimiento", detailMaxWidth: 650 } },
  { name: "Admin.Settings.QRAccess", component: QRAccessSettingsScreen, options: { title: "Acceso QR" } },
  { name: "Admin.Settings.QRCategory", component: QRCategoryConfigScreen, options: { title: "Configuración QR" } },
  { name: "Admin.Settings.Notifications", component: NotificationsSettingsScreen, options: { title: "Notificaciones", detailMaxWidth: 650 } },
  { name: "Admin.Settings.Mora", component: MorosidadSettingsScreen, options: { title: "Morosidad", detailMaxWidth: 650 } },
  { name: "Admin.Settings.Vigilancia", component: VigilanciaSettingsScreen, options: { title: "App de vigilancia", detailMaxWidth: 650 } },
  { name: "Admin.Settings.Expenses", component: GastosSettingsScreen, options: { title: "Gastos", detailMaxWidth: 650 } },
  { name: "Admin.Settings.Reports", component: ReportsSettingsScreen, options: { title: "Reportes y solicitudes", detailMaxWidth: 650 } },
  { name: "Admin.Settings.ProviderAuth", component: ProviderAuthSettingsScreen, options: { title: "Autorización a proveedores", detailMaxWidth: 650 } },
        

  { name: "Admin.Announcement.Detail", component: AnnouncementDetailScreen, options: { title: "", detailMaxWidth: 650 } },

  { name: "Admin.Units.Fees.Balance", component: AdminUnitBalanceScreen, options: { title: "Detalle de Vivienda", detailMaxWidth: 650 } },

  // Vinte
  { name: "Vinte.PaymentRequests.New", component: NewPaymentRequestScreen, options: { title: "Nueva Solicitud de Pago" } },
  { name: "Vinte.PaymentRequests.Detail", component: PaymentRequestDetailScreen, options: { title: "Solicitud de Pago" } },
  { name: "Vinte.Providers.Detail", component: ProviderDetailScreen, options: { title: "Detalle del proveedor" } },
  { name: "Admin.Vinte.Reports.Detail", component: VinteReportDetailScreen, options: { title: "Reporte" } },
]


// Para cuestion de prueba, simular el stack de native
// const MyAdminWebNavigator = createNativeStackNavigator();

const MyAdminWebNavigator = createMyAdminNavigator()


export default function MasterNavigatorStack({ ...props }: any) {
  console.log("MasterNavigatorStackProps", props?.route?.params?.params)

  return (
    <MyAdminWebNavigator.Navigator
      screenOptions={{
        headerShown: false,
        sideBar: (sidebarProps: any) => <AdminSidebar {...sidebarProps} />,
        topBar: (topBarProps: any) => <AdminTopBar {...topBarProps} />,
      }}>

      {MainStackScreens.map(screen =>
        <MyAdminWebNavigator.Screen
          key={screen.name}
          name={screen.name}
          component={screen.component}
          options={screen.options}
          initialParams={props?.route?.params?.params}
        />
      )}

    </MyAdminWebNavigator.Navigator>
  )
}





//  Para debug
// const ChildrenWebNavigator = createBottomTabNavigator();
const ChildrenWebNavigator = createChildrenNavigator()

function DeepStackNavigator({ route }: any) {
  return (
    <ChildrenWebNavigator.Navigator
      initialRouteName={DeepStackScreens[0].name}
      screenOptions={{
        headerShown: false,
      }}
    >
      {DeepStackScreens.map(screen =>
        <ChildrenWebNavigator.Screen
          key={screen.name}
          name={screen.name}
          component={screen.component}
          options={{
          }}
          initialParams={{ ...route.params, ...(screen as any).initialParams || {} }}
        />
      )}
    </ChildrenWebNavigator.Navigator>
  )
}

